<template>
  <div id="analisar-dados-formulario" class="container main">
    <div class="row align-items-end">
      <div class="col-md-4">
        <div class="form-group">
          <label for="tipo-analise">Tipo de avaliação</label>
          <vue-select
            v-model="tipoAnalise"
            :options="tiposAnalise"
            label="label"
            placeholder="Digite para pesquisar..."
            @input="onTipoAnaliseChange"
            class="vue-select"
          >
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group form-group-periodo">
          <label>Período da avaliação</label>
          <date-range-picker
            ref="picker"
            :opens="'right'"
            :locale-data="localeData"
            :minDate="minDate"
            :maxDate="maxDate"
            :autoApply="true"
            :ranges="ranges"
            v-model="dateRange"
            @update="onDateRangeChange"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              {{ formatDate(picker.startDate) }} -
              {{ formatDate(picker.endDate) }}
            </template>
          </date-range-picker>
        </div>
      </div>
      <div class="col-md-1 d-flex align-items-center justify-content-center">
        <button
          id="botaoLimparFiltros"
          class="btn btn-outline-secondary btn-sem-bg"
          @click="limparFiltrosDeData"
        >
          <i class="icofont-ui-delete icone-cinza-escuro"></i>
        </button>
      </div>
      <div id="idquecontemochat" class="col-md-2">
        <div id="conteudo-dos-botoes" class="d-flex align-items-center">
          <button
            id="botaochat"
            class="btn btn-secondary btn-filtro-chat"
            @click="$bvModal.show('chat-modal')"
          >
            <i class="icofont-ui-chat"></i> Chat
          </button>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <tabela-avaliacao-treinamento
        :cadastros="dadosFiltrados"
        :loading="loading"
        :tipoAnalise="tipoAnaliseReal"
      ></tabela-avaliacao-treinamento>
    </div>

    <b-modal id="chat-modal" title="Notificação" hide-footer>
      <template v-slot:modal-header>
        <h5 class="modal-title">Chat</h5>
        <button
          type="button"
          class="close"
          @click="$bvModal.hide('chat-modal')"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="modal-body">
        <p>Em desenvolvimento...</p>
      </div>
      <div class="modal-footer">
        <b-button variant="primary" @click="$bvModal.hide('chat-modal')"
          >OK</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import vueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { api } from '@/plugins/axios'
import SectionTitle from '@/components/SectionTitle'
import TabelaAvaliacaoTreinamento from './TabelaAvaliacaoTreinamento.vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  components: {
    'vue-select': vueSelect,
    SectionTitle,
    TabelaAvaliacaoTreinamento,
    DateRangePicker,
  },
  data() {
    return {
      tipoAnalise: { label: 'COMENTÁRIOS' },
      tiposAnalise: [
        { label: 'SUS Digital' },
        { label: 'COMENTÁRIOS' },
        { label: 'TEMAS SUGERIDOS' },
      ],
      dateRange: {
        startDate: this.getQuadrimestrePassadoStartDate(),
        endDate: new Date(),
      },
      localeData: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'S',
        customRangeLabel: 'Intervalo personalizado',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },
      ranges: {
        'Esta semana': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay())
          ),
          new Date(),
        ],
        'Semana passada': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
          ),
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
          ),
        ],
        'Este mês': [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(),
        ],
        'Mês passado': [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(new Date().getFullYear(), new Date().getMonth(), 0),
        ],
        'Este quadrimestre': [
          new Date(
            new Date().getFullYear(),
            Math.floor(new Date().getMonth() / 4) * 4,
            1
          ),
          new Date(),
        ],
        'Quadrimestre passado': [
          this.getQuadrimestrePassadoStartDate(),
          new Date(
            new Date().getFullYear(),
            Math.floor(new Date().getMonth() / 4) * 4,
            0
          ),
        ],
      },
      minDate: null,
      maxDate: new Date().toISOString().substr(0, 10),
      equipe: null,
      equipes: [],
      dadosAnalisados: [],
      dadosFiltrados: [],
      loading: false,
      modalChat: false,
      dataFiltrada: false,
      messages: [
        { text: 'Bem-vindo ao bate-papo! Como posso ajudar?' },
        { text: 'Quais são os horários de funcionamento?' },
      ],
      newMessage: '',
    }
  },
  computed: {
    tipoAnaliseReal() {
      if (this.tipoAnalise.label === 'COMENTÁRIOS') {
        return { label: 'AVALIAÇÃO DOS PARTICIPANTES' }
      }
      return this.tipoAnalise
    },
    descricaoTitulo() {
      switch (this.tipoAnalise?.label) {
        case 'SUS Digital':
          return 'Opinião sobre o SUS Digital'
        case 'COMENTÁRIOS':
          return 'Avaliação dos Participantes'
        case 'TEMAS SUGERIDOS':
          return 'Temas Sugeridos'
        default:
          return 'Descrição'
      }
    },
    dateRangeText() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        return `${this.formatDate(
          this.dateRange.startDate
        )} - ${this.formatDate(this.dateRange.endDate)}`
      }
      return ''
    },
  },
  mounted() {
    const data = this.$store.state.equipesV2
    if (data?.length) {
      this.equipes = data.map((item) => ({
        no_unidade_saude: item.no_unidade_saude,
        nu_cnes: item.nu_cnes,
      }))
      const coIbge = data[0].co_ibge
      this.fetchAvaliacaoTreinamento(coIbge)
    }
  },
  methods: {
    getQuadrimestrePassadoStartDate() {
      const now = new Date()
      const month = now.getMonth()
      const year = now.getFullYear()
      const startMonth = Math.floor((month - 4) / 4) * 4
      return new Date(year, startMonth, 1)
    },
    getQuadrimestreAtualStartDate() {
      const now = new Date()
      const month = now.getMonth()
      const year = now.getFullYear()
      const startMonth = Math.floor(month / 4) * 4
      return new Date(year, startMonth, 1)
    },
    onTipoAnaliseChange() {
      this.filtrarDados()
    },
    filtrarDados() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.dadosFiltrados = this.dadosAnalisados.filter((dado) => {
          const dataTreinamento = new Date(dado.dt_treinamento)
          return (
            dataTreinamento >= new Date(this.dateRange.startDate) &&
            dataTreinamento <= new Date(this.dateRange.endDate)
          )
        })
      } else {
        this.dadosFiltrados = this.dadosAnalisados
      }
    },
    onDateRangeChange(range) {
      this.dateRange = range
      this.filtrarDados()
    },
    limparFiltrosDeData() {
      this.dateRange = { startDate: null, endDate: null }
      this.dataFiltrada = false
      this.filtrarDados()
    },
    getDescricao(dado) {
      switch (this.tipoAnaliseReal?.label) {
        case 'SUS Digital':
          return dado.descricao_compreensao_usuario
        case 'AVALIAÇÃO DOS PARTICIPANTES':
          return dado.opiniaoTreinamento
        case 'TEMAS SUGERIDOS':
          return dado.sugestao_tema
        default:
          return ''
      }
    },
    fetchAvaliacaoTreinamento(coIbge) {
      this.loading = true
      api
        .get(`/app/avaliacao-treinamento/${coIbge}`)
        .then((response) => {
          if (response.data?.length) {
            this.dadosAnalisados = response.data
            this.filtrarDados()
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatDate(date) {
      if (!date) return ''
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(date).toLocaleDateString('pt-BR', options)
    },
    sendMessage() {
      if (this.newMessage.trim() !== '') {
        this.messages.push({ text: this.newMessage })
        this.newMessage = ''
      }
    },
    removeMessage(index) {
      this.messages.splice(index, 1)
    },
    startRecording() {
      // Função de gravação a ser implementada
      alert('Gravação iniciada...')
    },
  },
}
</script>

<style scoped>
#analisar-dados-formulario .info-table {
  margin-top: 20px;
}

#analisar-dados-formulario .form-group {
  margin-bottom: 15px;
}

#analisar-dados-formulario .form-group-periodo {
  display: flex;
  flex-direction: column;
}

#analisar-dados-formulario .d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: flex-start;
}

#analisar-dados-formulario .mr-2 {
  margin-right: 10px;
}

#analisar-dados-formulario .vue-select {
  width: 100%;
  text-transform: uppercase;
}

#analisar-dados-formulario .main {
  padding: 20px;
}

#analisar-dados-formulario .table {
  margin-top: 20px;
}

#analisar-dados-formulario .align-items-end {
  align-items: center !important;
}

#analisar-dados-formulario .btn-filtro-chat {
  margin-bottom: 9px;
}

#analisar-dados-formulario .table-date {
  white-space: nowrap;
}

#analisar-dados-formulario #botaochat {
  margin-left: 10px;
  margin-bottom: -20px;
}

#analisar-dados-formulario #botaochat:hover {
  color: #ffffff;
}

#botaoLimparFiltros {
  margin-bottom: -12px;
  background-color: transparent;
  border: none;
  box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%), 0 3px 1px -2px rgba(0, 0, 0, -3.8),
    0 1px 5px 0 rgba(0, 0, 0, -5.88);
  margin-left: -180px;
  font-size: 20px;
}

#botaoLimparFiltros .icone-cinza-escuro {
  color: #555;
}

@media (max-width: 767px) {
  #botaoLimparFiltros {
    display: none;
  }
}

#analisar-dados-formulario .btn-filtro-chat.mr-2 {
  margin-right: 10px;
}

#analisar-dados-formulario .btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}

#analisar-dados-formulario .btn-danger:hover {
  background-color: #c82333;
  border-color: #bd2130;
}
</style>
